export default __webpack_public_path__ + "static/media/Group 6827.e89a73b5.png";